module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhudNAP81HP8YDPsYAOccAP8MAP8EAOsIBPMAAOMAADUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAACH5BAEHABsALAAAAAAgACAAAAXr4CaOZGmeaKmtWuqi7Ri/tFYc4nHMNHwgiMNgoOP1SBrdLzgsHlVKHVCoNNaI0YOClVw9k4nsoXK5rHYrgNrVWkYfrEWXkn7FDongmBVZKCEsdjkJeRUsEhJZDoEpbVWGGg0MQgRRXGxRGRmRDTpYOgJoXo1VGhYYBwZiSmajPmgWOqqrOpuuJ0lKU7RiVkgsvFlnO2wrF8FFwMSNGhUTwSsWExqqtyUAK9O0LBZJs74ialy9GMpVKQAi3Jbjwj3RFcnm50fAXLl6y19dLGFaTk9k4BlmKSAUf/nAfdERgJ5BEwQVPrz0sOKIEAA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNW_S6.gif
// module id = 2Czn
// module chunks = 48